export default {
    dashboard_gadget_preview: "Preview",
    dashboard_gadget_title: "Title",
    dashboard_gadget_frequency_refresh: "Frequency Refresh",
    dashboard_gadget_report_type: "Report Type",
    dashboard_gadget_developers: "Developers",
    dashboard_gadget_chart_type: "Chart Type",
    dashboard_gadget_time_metric: "Time Metric",

    dashboard_gadget_five_minutes: "5 Minutes",
    dashboard_gadget_fifteen_minutes: "15 Minutes",
    dashboard_gadget_thirty_minutes: "30 Minutes",
    dashboard_gadget_one_hour: "1 Hours",
    dashboard_gadget_two_hour: "2 Hours",
    dashboard_gadget_this_month: "This Month",
    dashboard_gadget_last_month: "Last Month",
    dashboard_gadget_this_quarter: "This Quarter",
    dashboard_gadget_last_quarter: "Last Quarter",
    dashboard_gadget_this_year: "This Year",
    dashboard_gadget_last_year: "Last Year",

    dashboard_gadget_column: "Column",
    dashboard_gadget_line: "Line",

    dashboard_gadget_all_developers: "All Developers",
    dashboard_gadget_developers_metrics: "Developer Metrics",
    dashboard_gadget_developer: "Developer",
    dashboard_gadget_example: "Example",

    dashboard_gadget_today: "Today",
    dashboard_gadget_yesterday: "Yesterday",
    dashboard_gadget_thisweek: "This Week",
    dashboard_gadget_lastweek: "Last Week",
    dashboard_gadget_last7days: "Last 7 days",
    dashboard_gadget_last15days: "Last 15 days",
    dashboard_gadget_last30days: "Last 30 days",
    dashboard_gadget_custom: "Custom",

    dashboard_gadget_age: "Age (Days)",
    dashboard_gadget_account_status: "Account Status",
    dashboard_gadget_device_status: "Device Status",

    dashboard_gadget_min_length_message: "The age must contain a minimum of characters:",
    dashboard_gadget_max_length_message: "The age must contain a maximum of characters:",
    dashboard_gadget_define_maximum: "Define the maximum value period of days to evaluate that they are reporting",
    dashboard_gadget_define_initial_value: "Define the initial value of days that are not reporting",
    dashboard_gadget_define_interval_value: "Define the interval in days to generate the chart",
    dashboard_gadget_define_interval: "Interval",
    dashboard_gadget_imei: "IMEI or Serial",
}